module.exports = __webpack_public_path__ + "static/media/PlutoLight.10bd331d.woff";